<template>
  <O3D>
    <O3D :sx="0.5" :sy="0.5" :sz="0.5" :px="200" :pz="-300" :py="-0.7" :ry="pi * 0.14">
      <FactoryPlace v-if="chroma" :envMap="chroma.out.envMap"></FactoryPlace>
    </O3D>
    <!-- <SwatWalk></SwatWalk> -->
    <O3D :sx="5" :sy="5" :sz="5" :pz="-50">
      <O3D :px="0" :pz="10" :py="50">
        <PointLight :decay="2" :distance="0" :color="0xffffff" :helper="isDev && isOff" :intensity="0.4"></PointLight>
      </O3D>

      <O3D :px="0" :pz="-10" :py="18">
        <PointLight :decay="2" :distance="0" :color="0xffffff" :helper="isDev && isOff" :intensity="0.4"></PointLight>
      </O3D>

      <O3D :px="25" :pz="25" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="-25" :pz="25" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="25" :pz="-25" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="-25" :pz="-25" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="0" :pz="0" :py="0">
        <AmbinetLight :color="0xffffff" :helper="isDev && isOff" :intensity="0.2"></AmbinetLight>
      </O3D>
    </O3D>

    <!--
    -->
    <!-- <O3D :py="0" :rx="pi * -0.5" :sx="1.0" :sy="1.0" :sz="1.0">
      <WoozyDiamonds v-if="cubeCam"></WoozyDiamonds>
    </O3D> -->

    <!-- <GameNPC :px="13" :pz="-25" :char="'swat'" :dance="'Warming Up'"></GameNPC> -->
    <!-- <GameNPC v-if="chroma" ref="npc" :pz="-15" :char="'swat'" :dance="'Warming Up'"></GameNPC> -->
    <GameNPC v-if="chroma" ref="npc" :pz="-25" :char="'swat'" :dance="'Warming Up'"></GameNPC>
    <!-- <GameNPC :px="-13" :pz="-25" :char="'swat'" :dance="'Warming Up'"></GameNPC> -->
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
// import { Actions } from '../../GLContent/Game/Actions.js'
// import { CharNPC } from '../../GLContent/Game/CharNPC.js'
import { ShaderCubeChrome } from '../../Reusable/ShaderCubeChrome'
import { Color, Vector3, Object3D } from 'three'
// import { PCamera } from '../../Reusable/PCamera'
// import { CubeCam } from '../../Reusable/CubeCam'

export default {
  mixins: [O3DG2],
  data () {
    return {
      // mainChar: window.innerWidth >= 1280 ? 'swat' : 'swat',
      chroma: false,
      ready: false,
      layouts: {}
    }
  },
  methods: {
    async setup () {
      let lay = this.layouts
      this.onLoop(() => {
        lay.overall = {
          pz: -50
        }
      })
      this.ready = true
    }
  },
  async mounted () {
    this.setup()

    // this.cubeCam = new CubeCam({
    //   res: 64,
    //   renderer: this.ctx.renderer,
    //   scene: this.ctx.scene,
    //   camera: this.ctx.camera,
    //   loop: this.onLoop,
    //   clean: this.onClean
    // })

    this.chroma = new ShaderCubeChrome({
      res: 32,
      renderer: this.ctx.renderer,
      loop: this.onLoop,
      color: new Color('#ffffff')
    })

    // this.ctx.camera.position.z = 10
    // this.ctx.camera.position.y = 13

    this.lookAtMe = new Object3D()
    // this.lookAtMe.add(this.ctx.camera)
    // this.lookAtMe.position.y = 0
    // this.lookAtMe.position.z = 30
    let configCam = false

    let TempVec3 = new Vector3()
    let TempVec3Lerp = TempVec3.clone()
    this.onLoop(() => {
      if (this.$refs.npc) {
        if (this.$refs.npc.npc && this.$refs.npc.npc.isReady) {
          if (!configCam) {
            configCam = true
            this.$refs.npc.npc.skeleton.mixamorigHead.add(this.lookAtMe)
            this.lookAtMe.position.y = -23
            this.lookAtMe.position.z = 10
          }

          this.lookAtMe.updateMatrixWorld()
          TempVec3.setFromMatrixPosition(this.lookAtMe.matrixWorld)
          TempVec3Lerp.lerp(TempVec3, 0.1)

          this.ctx.camera.position.x = TempVec3.x
          this.ctx.camera.position.y = TempVec3.y
          this.ctx.camera.position.z = TempVec3.z + 15
          this.ctx.camera.lookAt(TempVec3Lerp)
        }
      }
    })

    // await Promise.all([
    //   // Actions.preloadByName({ name: 'Northern Soul Floor Combo' }),
    //   // CharNPC.preloadByName({ name: 'swat' }),
    //   // CharNPC.preloadByName({ name: 'swat' })
    // ])
  }
}
</script>

<style>

</style>